<template>
  <editor-form :can-back="true" @submit.prevent="showConfirmModal" @back="toViewer">
    <vuex-text-form-item label="会社名" :required="true" bind="name" />
    <vuex-text-form-item label="会社名（カナ）" :required="true" bind="name_kana" />
    <vuex-licence-form-item :required="true" />
    <vuex-select-form-item label="更新回数" bind="licence_update" :options="this.$constant.LICENCE.COUNT_LIST" :nullable="false" value-key="value" />
    <vuex-postal-code-form-item :required="true" />
    <vuex-prefecture-form-item :required="true" />
    <vuex-text-form-item label="市区町村" :required="true" bind="address1" />
    <vuex-text-form-item label="番地・建物など" :required="true"  bind="address2" />
    <vuex-text-form-item label="電話番号" :required="true" bind="tel" />
    <vuex-text-form-item label="FAX番号" bind="fax" />
  </editor-form>
  <teleport to="body">
    <edit-confirm-modal @update="doUpdate" ref="confirmModal" />
  </teleport>
</template>

<script>
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent'
import EditorForm from "@/views/templates/forms/EditorForm";
import VuexTextFormItem from '@/views/molecules/formItems/VuexTextFormItem'
import VuexLicenceFormItem from '@/views/molecules/formItems/VuexLicenceFormItem'
import VuexPostalCodeFormItem from '@/views/molecules/formItems/VuexPostalCodeFormItem'
import VuexPrefectureFormItem from '@/views/molecules/formItems/VuexPrefectureFormItem'
import EditConfirmModal from '@/views/molecules/modals/EditConfirmModal'
import VuexSelectFormItem from "@/views/molecules/formItems/VuexSelectFormItem";

export default {
  name: "BrokerageCompanyEditor",
  components: {
    EditorForm,
    VuexTextFormItem,
    VuexLicenceFormItem,
    VuexPostalCodeFormItem,
    VuexPrefectureFormItem,
    EditConfirmModal,
    VuexSelectFormItem,
  },
  mixins: [AddonLoadPageEvent],
  inject: ["$constant"],
  provide: {
    bindModule: 'brokerage_company_form'
  },
  methods: {
    loadPage() {
      return this.$store.dispatch('brokerage_company_form/load').catch(() => this.$root.failApi());
    },
    showConfirmModal() {
      this.$refs.confirmModal.show();
    },
    doUpdate() {
      this.$store.dispatch('brokerage_company_form/update').then(() => {
        this.$router.push({name: 'BrokerageCompanyViewer'});
      }).catch(reason => this.$root.failApi(reason));
    },
    toViewer() {
      this.$router.push({name: 'BrokerageCompanyViewer'});
    },
  }
}
</script>
